module.exports = __webpack_public_path__ + "static/media/jellyfish.23e490a9.jpg";